import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import MaterialIcon from "shared/react_components/MaterialIcon";
import DebouncedInput from "shared/react_components/DebouncedInput";

import { wrapper, input, icon } from "./SearchInput.module.scss";

const SearchInput = ({ className, style, ...props }) => (
  <div className={classNames(wrapper, className)} style={style}>
    <MaterialIcon name="search" className={icon} />
    <DebouncedInput
      aria-label="Search"
      type="input"
      className={input}
      timeout={500}
      {...props}
    />
  </div>
);

SearchInput.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

SearchInput.defaultProps = {
  className: "",
  style: {}
};

export default SearchInput;
